import { render } from "./CourseworkMarkEntry.vue?vue&type=template&id=4e9a3c86"
import script from "./CourseworkMarkEntry.vue?vue&type=script&lang=js"
export * from "./CourseworkMarkEntry.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src511626146/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__